import React from "react";

const About = () => {
  return (
    <section className="section about-section">
      <h1 className="section-title">about us</h1>
      <p>
        This is a humanitarian help web site with information
        useful for Ukrainian refugees seeking to settle in other country.
        <br></br>
        There is no business purpose in this web site.
      </p>
    </section>
  );
};

export default About;
